import axios from 'axios';

// REACT_APP_API_V1=https://api.autopaquete.com.mx/v1
const DEFAULT_TIMEOUT = process.env.REACT_APP_API_TIMEOUT || 10000;
// POST
const apiV1AxiosInstanceLogin = axios.create({
  baseURL: process.env.REACT_APP_API_V1,
  timeout: DEFAULT_TIMEOUT,
  responseType: 'json',
  headers: {
    'Content-Type': 'application/json',
    accept: '*/*',
  },
});
// GET
const msZipCodeAxiosInstance = axios.create({
  baseURL: `https://postalcodes.autopaquete.com.mx/coberturas/detalles-codigo-postal`,
  timeout: DEFAULT_TIMEOUT,
  responseType: 'json',
  headers: {
    Authorization: 'Token 70cb427de4630ca4d8d2447fafb359700539e306',
    'Content-Type': 'application/json',
  },
});
// POST
const checkClabeAxiosInstance = axios.create({
  baseURL: 'https://payments.autopaquete.com.mx/api/check-clabe/',
  timeout: DEFAULT_TIMEOUT,
  responseType: 'json',
});

// GET
const apiV1AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_V1,
  timeout: DEFAULT_TIMEOUT,
  responseType: 'json',
  headers: {
    'Content-Type': 'application/json', // Enviamos datos en JSON
    accept: '*/*',
    //  Accept: 'application/json', // Solicitamos una respuesta en JSON
  },
});
const apiV1AxiosInstanceForm = axios.create({
  baseURL: process.env.REACT_APP_API_V1,
  timeout: DEFAULT_TIMEOUT,
  responseType: 'json',
  headers: {
    'Content-Type': 'multipart/form-data',
    accept: '*/*',
  },
});
const apiV1AxiosProvisionalInstance = axios.create({
  baseURL: process.env.REACT_APP_API_V1,
  timeout: DEFAULT_TIMEOUT,
  responseType: 'json',
  headers: {
    'Content-Type': 'application/json', // Enviamos datos en JSON
    accept: '*/*',
  },
});
const getToken = () => {
  try {
    const storedData = localStorage.getItem('persist:starter-project');
    if (!storedData) return null;
    const parsed = JSON.parse(storedData);
    const authData = JSON.parse(parsed.auth);
    return authData?.currentUser?.isVerified ? authData?.currentUser?.api_key : '6581c1aff09cf0aeefdf455b48f6853fe3a5f574';
  } catch (error) {
    console.error('⚠️ Error al obtener el token:', error);
    return null;
  }
};
const getProvisionalToken = () => {
  try {
    const storedData = localStorage.getItem('persist:starter-project');
    if (!storedData) return null;
    const parsed = JSON.parse(storedData);
    const authData = JSON.parse(parsed.auth);
    return authData?.currentUser?.api_key || null;
  } catch (error) {
    console.error('⚠️ Error al obtener el token:', error);
    return null;
  }
};
// Agregar un interceptor de solicitudes para actualizar el token antes de cada solicitud
apiV1AxiosInstance.interceptors.request.use(
  (config) => {
    try {
      const token = getToken();
      // throw new Error('💥 Error manual de prueba');
      // ('📡 Interceptor token:', token);
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      if (!token) {
        console.warn('⚠️ [Interceptor] Token ausente. Revisa si el usuario está logueado.');
      }
      return config;
    } catch (err) {
      console.error('🚨 Error en interceptor:', err);
      return Promise.reject(err);
    }
  },
  (error) => Promise.reject(error)
);
apiV1AxiosInstanceForm.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
apiV1AxiosProvisionalInstance.interceptors.request.use(
  (config) => {
    const token = getProvisionalToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export { apiV1AxiosInstance, apiV1AxiosInstanceLogin, checkClabeAxiosInstance, msZipCodeAxiosInstance, apiV1AxiosInstanceForm, apiV1AxiosProvisionalInstance };
